import AboutAstrology from "./About-Astrology";
import AboutUs from "./About-Us";
import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import PujaGallery from "./PujaGallery";
import PujaVideos from "./PujaVideo";
import KundliInfo from "./KundliInfo";

export function Home({ language }) {
    const [imageLoaded, setImageLoaded] = useState(false);
    const bgImage = "/image/bg/astrobg.webp";
      useEffect(() => {
        const img = new Image();
        img.src = bgImage; // Ensure correct path
        img.onload = () => setImageLoaded(true);
      }, []);

    return (
        <>
         {/* <Helmet>
        <title>Astro Mahamaya - Best Astrology Services</title>
        <meta name="description" content="Is your future written in the stars?  Astrology is an ancient Vedic science that studies the effects of planetary movements and celestial influences on our lives. 
It includes daily horoscope predictions, zodiac sign analysis, and Vedic remedies, which can guide you in the right direction. Whether you're seeking career
 guidance, relationship advice, or life solutions, astrology offers profound insights to help you unlock your true potential. " />
        <meta name="keywords" content="Astrology, Horoscope, Vedic Astrology, Astro Mahamaya, Vedic science, Planetary movements, Celestial influences, Daily horoscope predictions,Zodiac sign analysis, Vedic remedies, Career guidance,Relationship advice,Life solutions" />
        <meta name="author" content="Astro Mahamaya" />
        <meta property="og:title" content="Astro Mahamaya - Best Astrology Services" />
        <meta property="og:description" content="Get expert astrology services with Astro Mahamaya." />
        <meta property="og:url" content="https://astromahamaya.com/" />
        <meta property="og:type" content="website" />
      </Helmet> */}
            {/* Hero Section */}
            <div 
                className="relative bg-yelllow-400 flex flex-col items-center justify-center min-h-[90vh] md:h-screen text-center px-6 py-10"
                
            >
                <img
                    src={bgImage}
                    alt="Astrology Background"
                    className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-300 ${
                        imageLoaded ? "opacity-100" : "opacity-0"
                    }`}
                    loading="eager"
                    decoding="async"
                />
                {/* Dark Overlay */}
                <div className="absolute inset-0 bg-yellow-300 bg-opacity-80"></div>

                {/* Hero Content */}
                <div className="relative z-10 max-w-3xl mx-auto mt-40">
                    <h1 className="text-4xl md:text-6xl font-extrabold text-black drop-shadow-lg animate-fadeInUp">
                        Discover the Power of Astrology  
                    </h1>
                    <h2 className="text-2xl md:text-3xl font-semibold text-black mt-4">
                        ज्योतिष की शक्ति को पहचानें  
                    </h2>

                    <p className="text-lg md:text-xl mt-4 text-gray-600 leading-relaxed animate-fadeIn">
                        Connect with cosmic wisdom and unlock your life's potential.  
                    </p>
                    <p className="text-md md:text-lg text-gray-600 leading-relaxed">
                        ब्रह्मांडीय ज्ञान से जुड़ें और अपने जीवन की संभावनाओं को खोलें।  
                    </p>

                    {/* Call-to-Action Button */}
                    <button
                        className="mt-6 px-6 md:px-8 py-3 md:py-4 bg-gradient-to-r from-purple-600 to-indigo-600 text-white text-lg font-semibold rounded-lg shadow-lg transform hover:scale-105 transition-all hover:from-yellow-400 hover:to-yellow-300 hover:text-black"
                        onClick={() => document.getElementById('astrology')?.scrollIntoView({ behavior: 'smooth' })}
                    >
                        Explore More | और जानें  
                    </button>
                </div>
            </div>

            {/* Additional Sections */}
            <AboutAstrology  language={language} />
            <AboutUs   language={language}/>
            <KundliInfo language={language}/>
            <PujaGallery/>
            <PujaVideos/>
            
        </>
    );
}
